<template>
  <div v-if="load != 3" :style="{height: height}" class="empty-wrap">
    <div v-if="load == 2">
      <Icon style="animation: ani-demo-spin 1s linear infinite;" type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </div>
    <div v-if="load == 1">
      <Icon :size="30" type="ios-document-outline" />
      <font style="vertical-align: inherit;line-height: 30px;">{{tip}}</font>
    </div>
  </div>
</template>
<script>

export default {
  name: "faces",
  components: {},
  data() {
    return {
    };
  },
  props: {
    tip: {
      default: '无信息'
    },
    height: {
      default: '100px'
    },
    load: {
      default: 1
    }
  },
  methods: {
    
  }
};
</script>

<style scoped lang="scss">
  .empty-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
</style>
